<template>
  <v-row class="px-4 pt-3 pb-4 details-proposal__card-auto">
    <v-col cols="12">
      <p class="primary--text font-weight-bold mb-2">
        Coberturas:
      </p>
    </v-col>
    <v-col cols="12" class="details-proposal__item-auto">
      <v-row class="px-4 py-6">
        <v-col cols="12" md="6">
          <p
            class="caption darkBluishGray--text mb-2 font-weight-bold details-proposal__text-height"
          >
            Básica
          </p>
          <v-row>
            <v-col cols="12" md="6">
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Granizo
              </p>
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Seca
              </p>
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Geada
              </p>
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Vendaval/ Ventos Fortes
              </p>
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Tromba D'agua
              </p>
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Variação Exceciva de Temperatura
              </p>
            </v-col>
            <v-col cols="12" md="6">
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Chuva Excessiva
              </p>
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Inundação/ Alagameto
              </p>
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Imprevisto e Inevitável
              </p>
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Raio
              </p>
              <p
                class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
              >
                Incêndio
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" v-if="hasAditionalCoverage">
          <p
            class="caption darkBluishGray--text mb-2 font-weight-bold details-proposal__text-height"
          >
            Adicional de Replantio
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Granizo
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Tromba D'agua
          </p>
          <p
            class="caption darkBluishGray--text mb-2 font-weight-medium details-proposal__text-height"
          >
            Chuva Excessiva
          </p>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
import { asMoneyString, formatIsoDateToDDMMYYYY } from "@/utils/formats.js";

export default {
  name: "QuotationProposalAgricolaInformation",
  mixins: [DocumentsMixin],
  data() {
    return {
      asMoneyString,
      formatIsoDateToDDMMYYYY,
      closeTable: false
    };
  },
  methods: {
    closeTableBillingFile() {
      return (this.closeTable = true);
    }
  },
  computed: {
    hasAditionalCoverage() {
      return this.form.tipo_cobertura?.id === "basica_replantio";
    },
    isProductivity() {
      return this.form.tipo_seguro == "produtividade";
    },
    insuranceCompany() {
      return this.form.seguradora?.nome;
    },
    insuranceType() {
      return this.form.tipo_seguro?.nome;
    },
    claimType() {
      return this.form.tipo_reivindicacao?.nome;
    }
  },
  props: {
    form: {
      type: Object
    },
    isPolicy: {
      type: Boolean,
      default: false
    }
  }
};
</script>
